module.exports = __webpack_public_path__ + "img/coins.35a8efee.svg";